export default __webpack_public_path__ + "static/media/InvestmentOrange.ebaff5aa.svg";